import EnrollSettings from './src/main';

/* istanbul ignore next */
EnrollSettings.install = function(Vue) {
  Vue.component(EnrollSettings.name, EnrollSettings);
};

export default EnrollSettings;
